/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const COZE_V1_ROUTE_PREFIX = '/v1';

export const ABR_HOME_SUBMENU = 'develop';
/** @deprecated 使用 ABR_HOME_SUBMENU */
export const ABR_DEVELOP_V2_SUBMENU = ABR_HOME_SUBMENU;

/** 旧版 v1 使用 /v1 前缀，新版默认无前缀 */
export function getSpaceRoutePrefix(pathname: string): string {
  return pathname.startsWith(COZE_V1_ROUTE_PREFIX) ? COZE_V1_ROUTE_PREFIX : '';
}

export function isAbrDefaultSpaceRoute(pathname: string): boolean {
  return !pathname.startsWith(COZE_V1_ROUTE_PREFIX);
}

export function resolveSpaceSubMenu(
  subMenu: string,
  _routePrefix: string,
): string {
  if (subMenu === 'develop-v2') {
    return ABR_HOME_SUBMENU;
  }
  return subMenu;
}

export function buildSpaceWorkspacePath(
  routePrefix: string,
  spaceId: string,
  subMenu: string,
): string {
  return `${routePrefix}/space/${spaceId}/${resolveSpaceSubMenu(subMenu, routePrefix)}`;
}
